import React from 'react';
import { motion } from 'framer-motion';

const BlogCTA = () => {
  return (
    <div className="mt-20 py-12 px-8 bg-zinc-950 rounded-2xl border border-zinc-800 text-center">
      <h3 className="text-2xl font-bold text-white mb-4 uppercase tracking-tight">
        Scale Your Etsy Shop
      </h3>
      <p className="text-zinc-400 mb-8 max-w-md mx-auto">
        Get the **Etsy Shop Planner**—the exact command center used to manage listings, research keywords, and track growth without the spreadsheet chaos.
      </p>
      <a 
        href="https://alienproduction.etsy.com/listing/4486534006/etsy-shop-planner-notion-template" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="inline-block bg-white text-zinc-950 font-black px-10 py-4 rounded-md hover:bg-zinc-200 transition-all active:scale-[0.98] uppercase tracking-widest text-sm"
      >
        Get the Template
      </a>
    </div>
  );
};

export default BlogCTA;